import { useTranslation } from "react-i18next";
import "./DateSelector.css";
import {useState} from "react";

export type DateSelectorProps = {
    dateValue: string | undefined;
    dateError: string | null;
    disabled: boolean;
    onChange: (event: any) => void;
}

export const DateSelector = ({
    dateValue,
    dateError,
    disabled,
    onChange,
}: DateSelectorProps) => {
    const { t } = useTranslation("common");
    const [currentDate, setCurrentDate] = useState(dateValue ?? "");

    return (
        <div className="date-selector">
            <div className="date-selector__date-fields">
                <div className="date-selector__date-fields" id="embark">
                    <label htmlFor="date-selector">{t("reuseDocuments.validUntil")}</label>
                    <input
                        type="date"
                        id="date-selector"
                        className="date-input"
                        name="date-selector"
                        value={currentDate}
                        onChange={e => setCurrentDate(e.target.value)}
                        onBlur={onChange}
                        disabled={disabled}
                    />
                </div>
                {dateError && <p className="error" id="expiry-error">{dateError}</p>}
            </div>
        </div>
    )
}